import { RECEIPT_URL } from "constants/schedule";
import { getS3SignedUrl } from "./Utils";
import { is_empty } from "./validations";
import { downloadFileWithCustomName } from "./download/download.utils";

/**
 * Resolves a file record to an accessible URL.
 *
 * Most files are stored in our S3 bucket and need a signed URL. A few
 * integrations (for example Signzy contracts) return an external URL that
 * should be opened directly instead of being treated as an S3 key.
 *
 * @param {object} record: table record row data
 * @param {string} source: key in which data is coming
 * @returns {Promise<string|null>}
 */
const getAccessibleFileUrl = async (record, source) => {
  const fileUrl = record?.[source];
  if (is_empty(fileUrl)) return null;

  const isAbsoluteUrl = /^https?:\/\//i.test(fileUrl);

  if (isAbsoluteUrl) {
    try {
      const parsedUrl = new URL(fileUrl);
      if (!parsedUrl.hostname.includes("amazonaws.com")) {
        return fileUrl;
      }
    } catch (error) {
      return fileUrl;
    }
  }

  // substring(1) removes the leading "/" that comes from the pathname.
  const s3Key = isAbsoluteUrl
    ? new URL(fileUrl).pathname.substring(1)
    : String(fileUrl).replace(/^\/+/, "");

  try {
    const signedUrl = await getS3SignedUrl(s3Key);
    return signedUrl || (isAbsoluteUrl ? fileUrl : null);
  } catch (error) {
    return isAbsoluteUrl ? fileUrl : null;
  }
};

/**
 * convert the simple URL to the signed S3 URL for open/download the file
 * @param {object} record: table record row data
 * @param {string} source: key i which data is coming
 * @returns
 */
export const getSignedS3DownlaodURL = async (record, source = RECEIPT_URL) => {
  const url = await getAccessibleFileUrl(record, source);
  if (url) window.open(url);
};

/**
 * Downloads a file from a table record.
 * @param {object} record: table record row data
 * @param {string} source: key in which data is coming
 * @param {string} fileName: name of the downloaded file
 */
export const downloadS3File = async (
  record,
  source = RECEIPT_URL,
  fileName = "download.pdf"
) => {
  const url = await getAccessibleFileUrl(record, source);
  if (!url) return;
  downloadFileWithCustomName(url, fileName, Math.max(fileName.length, 10));
};
